var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items.length)?_c('details',{staticClass:"ai-evidence"},[_c('summary',[_vm._v("判断依据 · "+_vm._s(_vm.items.length)+" 处")]),_vm._v(" "),_vm._l((_vm.items),function(item){return _c('div',{key:item.id,staticClass:"ai-source"},[_c('b',[_vm._v(_vm._s(item.label))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.text))])])})],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a768a88","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ai-evidence.vue
// module id = null
// module chunks = 